import { Injectable } from '@angular/core';
import { MyDelegationsDto } from '@osos/shared/api';
import { DelegationPresenterModel } from '@osos/shared/types';
import { ParserBase } from '../../bases/parser/parser-base';

@Injectable()
export class DelegationParserV1Service extends ParserBase<
  MyDelegationsDto,
  DelegationPresenterModel
> {
  constructor() {
    super(MyDelegationsDto, DelegationPresenterModel, 1);
  }

  getPresenterModel(model: MyDelegationsDto): DelegationPresenterModel {
    return {
      id: model.id,
      toDate: new Date(model.to_date),
      fromDate: model.from_date ? new Date(model.to_date) : null,
      delegator: model.delegator,
    };
  }

  getDataModel(presenter: DelegationPresenterModel): MyDelegationsDto {
    throw new Error('Not Implemented');
  }
}
